module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "xi",
      "id": "pg_xi",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Each human life must work through all the joys and sorrows, gains and losses, which make up the history of the world.”")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THOMAS MANN")])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0